<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>自有课程</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- <div class="main-box searchBox">
     
      <el-form :inline="true" :model="formPackage" label-width="90px" class="searchForm">
        <el-form-item label="课包ID:">
          <el-input v-model="formPackage.id" placeholder="输入课包ID"></el-input>
        </el-form-item>
        <el-form-item label="课包名称:">
          <el-input v-model="formPackage.name" placeholder="输入课包名称"></el-input>
        </el-form-item>
        <el-form-item label="级别:">
          <el-input v-model="formPackage.level" placeholder="输入课包级别"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
        </el-form-item>
        
      </el-form>
    </div> -->
    <div class="tableList">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="体系课" name="first">
          <el-form
            :inline="true"
            :model="formPackage"
            label-width="90px"
            class="searchForm"
          >
            <!-- <el-form-item label="课包ID:">
          <el-input v-model="formPackage.id" placeholder="输入课包ID"></el-input>
        </el-form-item> -->
            <el-form-item label="课包名称:">
              <el-input
                v-model="formPackage.name"
                placeholder="输入课包名称"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="级别:">
          <el-input v-model="formPackage.level" placeholder="输入课包级别"></el-input>
        </el-form-item> -->
            <el-form-item>
              <el-button type="primary" icon="search" @click="onQuery"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
          <div class="operBtn">
            <el-button type="primary" icon="el-icon-plus" @click="addPackage"
              >新建课包</el-button
            >
          </div>

          <el-table
            ref="multipleTable"
            :data="queryData"
            tooltip-effect="dark"
            :header-cell-style="rowClass"
            id="Table"
            @selection-change="handleSelectionChange"
            v-loading.body="loading"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column
              prop="id"
              label="课包ID"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="viewPkg(scope.row, 'Course')"
                  style="color: #1d90e6"
                  >{{ scope.row.id }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="课包名称"
              align="center"
              width="300"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="viewPkg(scope.row, 'Course')"
                  style="color: #1d90e6"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="level"
              label="级别"
              align="center"
              min-width="80"
            ></el-table-column>
            <el-table-column
              prop="period"
              label="周期"
              align="center"
              min-width="80"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.period == 1">日</span>
                <span v-if="scope.row.period == 2">周</span>
                <span v-if="scope.row.period == 3">月</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              align="center"
              min-width="80"
            ></el-table-column>
            <el-table-column
              prop="updated_at"
              label="更新时间"
              align="center"
              min-width="150"
            >
            </el-table-column>
            <el-table-column
              prop="enabled"
              label="上下架状态"
              align="center"
              min-width="110"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.enabled" type="success">已上架</el-tag>
                <el-tag v-else type="danger">已下架</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="125"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="top">
                  <!-- <el-button type="info" size="mini" icon="edit" @click="handleEdit(scope.row)"></el-button> -->
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.row)"
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="复制" placement="top">
                  <el-button
                    type="primary"
                    icon="el-icon-copy-document"
                    @click="handleCopy(scope.row)"
                    size="mini"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div class="bottomOperBtn btnFlex">
            <el-button
              type="danger"
              @click="opPackage(0)"
              icon="delete2"
              style="margin-top: 20px"
              >删除</el-button
            >
            <el-button
              type="primary"
              @click="opPackage(1)"
              icon="arrow-up"
              style="margin-top: 20px"
              >上架</el-button
            >
            <el-button
              type="info"
              @click="opPackage(2)"
              icon="arrow-down"
              style="margin-top: 20px"
              >下架</el-button
            >
          </div>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="queryParams.page"
              :page-sizes="[20, 50, 100]"
              :page-size="queryParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="特色课程" name="second">
          <el-form
            :inline="true"
            :model="formExtra"
            label-width="140px"
            style="margin-left: 14px"
            class="searchForm"
          >
            <el-form-item label="特色课程名称:" >
              <el-input
                v-model="formExtra.name"
                placeholder="输入特色课程名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="search" @click="onQuery1"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
          <div class="operBtn">
            <el-button type="primary" icon="plus" @click="addExtra"
              >新建特色课程</el-button
            >
          </div>
          <el-table
            ref="multipleTable"
            :data="queryData"
            :header-cell-style="rowClass"
            id="Table"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column
              prop="id"
              label="特色课程ID"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="viewExtra(scope.row)"
                  style="color: #1d90e6"
                  >{{ scope.row.id }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="特色课程名称"
              align="center"
              min-width="300"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="viewExtra(scope.row)"
                  style="color: #1d90e6"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="level"
              label="级别"
              align="center"
              width="90"
            ></el-table-column>

            <el-table-column
              prop="count"
              label="数量"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="updated_at"
              label="更新时间"
              align="center"
              width="120"
            ></el-table-column>

            <el-table-column
              prop="enabled"
              label="状态"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.enabled" type="success">已上架</el-tag>
                <el-tag v-else type="danger">已下架</el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column
                prop="updated_at"
                label="更新时间"
                align="center"
                width="120"
              ></el-table-column> -->
            <!-- <el-table-column
                prop="enabled"
                label="状态"
                align="center"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.enabled" type="success"
                    >已上架</el-tag
                  >
                  <el-tag v-else type="danger">已下架</el-tag>
                </template>
              </el-table-column> -->
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="125"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="handleEdit1(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="复制" placement="top">
                  <el-button
                    type="primary"
                    icon="el-icon-copy-document"
                    @click="handleCopyAgin(scope.row)"
                    size="mini"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            type="danger"
            @click="delExtra"
            icon="delete2"
            style="margin-top: 20px"
            >删除</el-button
          >
          <el-button
            type="primary"
            @click="shangjiaExtra"
            icon="arrow-up"
            style="margin-top: 20px"
            >上架</el-button
          >
          <el-button
            type="info"
            @click="xiajiaExtra"
            icon="arrow-down"
            style="margin-top: 20px"
            >下架</el-button
          >
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page.sync="queryParams1.page"
              :page-sizes="[20, 50, 100]"
              :page-size="queryParams1.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal1"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <Modal v-model="logoutShow" width="470" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <!-- <span>
          <slot></slot>
        </span> -->
        <span>复制课包</span>
      </p>
      <el-form
        :inline="true"
        :model="formStu"
        label-width="100px"
        style="margin-left: 30px"
      >
        <el-form-item>
          <el-input
            v-model="formStu.copyName"
            placeholder="请输入名称"
            style="width: 380px"
          ></el-input>
        </el-form-item>
      </el-form>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 266px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>

    <Modal v-model="logoutShowAgin" width="470" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <!-- <span>
          <slot></slot>
        </span> -->
        <span>复制加油包</span>
      </p>
      <el-form
        :inline="true"
        :model="formClassStu"
        label-width="100px"
        style="margin-left: 30px"
      >
        <el-form-item>
          <el-input
            v-model="formClassStu.copyName"
            placeholder="请输入名称"
            style="width: 380px"
          ></el-input>
        </el-form-item>
      </el-form>
      <Divider />
      <el-button
        type="primary"
        @click="modalConfirmAgin"
        style="margin-left: 266px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>


<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "packageList",
  data() {
    return {
      logoutShow: false,
      logoutShowAgin: false,
      formPackage: {
        id: "",
        name: "",
        level: "",
      },
      formExtra: {
        name: "",
      },
      formStu: {
        copyName: "",
        id: "",
      },
      formClassStu: {
        copyName: "",
        id: "",
      },
      pageTotal: 0,
      pageTotal1: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      queryParams1: {
        page: 1,
        pageSize: 20,
      },
      multipleSelection: [],
      loading: true,
      activeName: "first",
      datanow: [],
    };
  },
  components: {},

  props: {},
  created() {
    this.fetchPackageList();
  },
  computed: {},
  mounted() {},
  watch: {},
  filters: {
    getDateRange(val) {
      if (val) {
        if (val[1] == 0 && val[0] != 0) {
          var starTime = formatDate(val[0], "yyyy-MM-dd");
          return `${starTime}——${"永久有效"}`;
        } else if (val[1] == 0 && val[1] == 0) {
          return `${"永久有效"}`;
        } else {
          var starTime = formatDate(val[0], "yyyy-MM-dd");
          var endTime = formatDate(val[1], "yyyy-MM-dd");
          return `${starTime}——${endTime}`;
        }
      }
    },
  },
  methods: {
    loadingBtn() {},
    modalCancel() {
      this.logoutShow = false;
      this.logoutShowAgin = false;
    },
    modalConfirm() {
      let params = {
        appId: this.$API.APPID,
        packageId: this.formStu.packageId,
        name: this.formStu.copyName,
      };
      this.$axios
        .post("edu/eduAdmin/course/package_copy", params)
        .then((response) => {
          if (response.data.rc == 0) {
            this.logoutShow = false;
            this.$message.success("复制成功");
            this.fetchPackageList();
          } else {
            alert(response.data.rc + ". " + response.data.err);
          }
          // if(){}
        });
    },
    modalConfirmAgin() {
      let params = {
        appId: this.$API.APPID,
        courseId: this.formClassStu.packageId,
        name: this.formClassStu.copyName,
      };
      this.$axios
        .post("edu/eduAdmin/course/course_copy", params)
        .then((response) => {
          if (response.data.rc == 0) {
            this.logoutShowAgin = false;
            this.$message.success("复制成功");

            this.fetchExtraList();
          } else {
            alert(response.data.rc + ". " + response.data.err);
          }
        });
    },
    handleCopy(data) {
      this.logoutShow = true;
      this.formStu.copyName = data.name + "复制";
      this.formStu.packageId = data.id;
    },
    handleCopyAgin(data) {
      this.logoutShowAgin = true;
      this.formClassStu.copyName = data.name + "复制";
      this.formClassStu.packageId = data.id;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.index == "0") {
        //tixike
        this.queryParams.page = 1;
        this.fetchPackageList();
      } else if (tab.index == "1") {
        //jiayoubao
        this.queryParams1.page = 1;
        this.fetchExtraList();
      }
    },
    addExtra() {
      this.$router.push({
        name: "extraAddNew",
      });
    },
    viewExtra(extra) {
      let routeData = this.$router.resolve({
        name: "myextra",
        query: {
          id: extra.id,
          albumId: extra.albumId,
        },
      });
      window.open(routeData.href, "_blank");
    },

    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchPackageList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        packageType: 1,
        isIncludeAuthInfo: true,
      };
      if (this.formPackage.id != "") {
        params.id = this.formPackage.id;
      }
      if (this.formPackage.name != "") {
        params.name = this.formPackage.name;
      }
      if (this.formPackage.level != "") {
        params.level = this.formPackage.level;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.queryData = m.list;
          this.pageTotal = m.pager.total;
        }
        this.loading = false;
      });
    },
    fetchExtraList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        courseType: 1,
        isIncludeAuthInfo: true,
      };
      if (this.formExtra.name != "") {
        params.name = this.formExtra.name;
      }
      // if (this.formExtra.level != "") {
      //   params.level = this.formExtra.level;
      // }
      params.pageSize = this.queryParams1.pageSize;
      params.page = this.queryParams1.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal1 = m.pager.total;
          }
          this.loading = false;
        }
      );
    },
    addPackage() {
      this.$router.push({
        name: "addCourse",
      });
    },
    onQuery() {
      this.queryParams.page = 1;
      this.fetchPackageList();
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    handleEdit(pkg) {
      this.$router.push({
        name: "addCourse",
        query: {
          id: pkg.id,
        },
      });
    },
    handleEdit1(pkg) {
      this.$router.push({
        name: "extraAddNew",
        query: {
          id: pkg.id,
        },
      });
    },
    viewPkg(pkg, type) {
      this.$router.push({
        name: "detailCourse",
        query: {
          id: pkg.id,
          type: type,
        },
      });
    },
    onQuery1() {
      this.queryParams1.page = 1;
      this.fetchExtraList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchPackageList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchPackageList();
    },
    handleSizeChange1(val) {
      this.queryParams1.pageSize = val;
      this.fetchExtraList();
    },
    handleCurrentChange1(val) {
      this.queryParams1.page = val;
      this.fetchExtraList();
    },

    delExtra() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择特色课程");
        return;
      }
      let getCount = [];
      let ids = [];
      for (let i in this.multipleSelection) {
        ids.push(`${this.multipleSelection[i].id}`);
        getCount.push(`${this.multipleSelection[i].authCount}`);
      }

      let newCnCoun = this.multipleSelection.filter((cid) => {
        return 0 == cid.authCount;
      });
      let newCtCoun = this.multipleSelection.filter((cid1) => {
        return 0 != cid1.authCount;
      });
      // console.log(newCnCoun, "---------");
      // console.log(newCtCoun, "----------");
      // console.log(ids, "ids====");
      // console.log(getCount, "得到的授权机构苏====");
      if (newCtCoun.length >= 1) {
        alert("课包正处于被授权状态中，请先去取消授权");
        return
      }
      this.$Modal.confirm({
        title: "确认删除？",
        content: "请确认是否删除特色课程",
        onOk: () => {
          let params = {
            appId: this.$API.APPID,
            courseIdList: ids,
          };
          // this.eduAxiosPostRequest(
          //   "/edu/eduAdmin/course/extra_del",
          //   params
          // ).then((res) => {
          //   if (res != null) {
          //     this.$Message.success("删除成功!");
          //     this.fetchExtraList();
          //   }
          // });
          this.$axios
            .post("/edu/eduAdmin/course/extra_del", params)
            .then((response) => {
              if (response != null) {
                this.$Message.success("删除成功!");
                this.fetchExtraList();
              }
            });
        },
      });
    },
    shangjiaExtra() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择特色课程");
        return;
      }
      let extraIdList = [];
      for (let i in this.multipleSelection) {
        extraIdList.push(`${this.multipleSelection[i].id}`);
      }
      this.shangxiajiaSendServer(extraIdList, true);
    },
    xiajiaExtra() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择特色课程");
        return;
      }
      let extraIdList = [];
      let getExtraCount = [];
      for (let i in this.multipleSelection) {
        extraIdList.push(`${this.multipleSelection[i].id}`);
        getExtraCount.push(`${this.multipleSelection[i].authCount}`);
      }
      let newCaCount = this.multipleSelection.filter((dt2) => {
        return 0 == dt2.authCount;
      });
      let newCatCount = this.multipleSelection.filter((dd2) => {
        return 0 != dd2.authCount;
      });

      let newsIds = newCaCount.map((ne1) => {
        return ne1.id;
      });
      // console.log(newsIds, "-------------------------");
      // console.log(newCatCount, "不为1newCatCount======");
      // console.log(newCaCount, "为1newCaCount-----");
      if (newCatCount.length >= 1) {
        alert("课包正处于被授权状态中，请先去取消授权");
        return;
      }

      this.shangxiajiaSendServer(newsIds, false);
    },
    shangxiajiaSendServer(newsIds, op) {
      // console.log(newsIds, "newsIds----");
      if (newsIds.length > 0) {
        let params = {
          appId: this.$API.APPID,
          courseIdList: newsIds,
          enabled: op,
        };
        this.$axios
          .post("/edu/eduAdmin/course/extra_batch", params)
          .then((response) => {
            if (response != null) {
              this.$Message.success("操作成功!");
            }
            this.fetchExtraList();
          });
      }
    },
    opPackage(type) {
      //0删除1上架2下架
      if (this.multipleSelection.length == 0) {
        alert("请先选择课包");
        return;
      }
      let ids = [];
      let datanow = [];
      for (let i in this.multipleSelection) {
        ids.push(`${this.multipleSelection[i].id}`);
        datanow.push(`${this.multipleSelection[i].authCount}`);
      }
      console.log(this.datanow, "this.datanow------");
      let newCount = this.multipleSelection.filter((dt) => {
        return 0 == dt.authCount;
      });
      let newNuthCount = this.multipleSelection.filter((dd) => {
        return 0 != dd.authCount;
      });
      console.log(newCount, "newCount=========");
      let newIds = newCount.map((ne) => {
        return ne.id;
      });

      if (newNuthCount.length >= 1) {
        alert("课包正处于被授权状态中，请先去取消授权");
        return;
      }
      if (type == 0) {
        // if(datanow!=0){}
        this.$Modal.confirm({
          title: "确认删除？",
          content: "<ul><li>请确认是否删除所选课包</li></ul>",
          onOk: () => {
            let params = {
              appId: this.$API.APPID,
              packageIdList: newIds,
            };
            this.eduAxiosPostRequest(
              "/edu/eduAdmin/course/package_del",
              params
            ).then((res) => {
              if (res != null) {
                this.$Message.success("删除成功!");
                this.fetchPackageList();
              }
            });
          },
        });
      } else {
        let enabled = false;
        if (type == 1) {
          enabled = true;
        }
        let params2 = {
          appId: this.$API.APPID,
          packageIdList: ids,
          enabled: enabled,
        };
        this.eduAxiosPostRequest(
          "/edu/eduAdmin/course/package_batch",
          params2
        ).then((res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchPackageList();
          }
        });
      }
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("package_del") != -1 ||
                address.indexOf("package_batch") != -1
              ) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";
// .searchBox {
//   background: #fff;
//   .el-form{
//     padding: 22px 0 0 0;
//   }
// }
// .table{
//     margin-top: 20px;
//     background: #fff;
// }
</style>



// WEBPACK FOOTER //
// courseList.vue?c700e69a